import { render } from "./pictureMobile.vue?vue&type=template&id=4b198e25&scoped=true"
import script from "./pictureMobile.vue?vue&type=script&lang=js"
export * from "./pictureMobile.vue?vue&type=script&lang=js"

import "./pictureMobile.vue?vue&type=style&index=0&id=4b198e25&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b198e25"]])

export default __exports__